
import { DefaultStyle, SamplesVerifiedStyle, SamplesUnverifiedStyle, SamplesMissedStyle } from "./features/map"
import { Style, Stroke, Fill } from 'ol/style';
import Hash from './shared/Hash';

export const Config = {

    path: "/product/osmplus/",

    metricModuleId: "OsmPlus",

    texts: {
        appName: "OpenStreetMap+",
        title: ['Дополняем OpenStreetMap', 'до правдоподобного'],
        subtitle: [],
        textInfos: [
            {
                upper: '',
                title: 'Быстро и недорого',
                text: ['Вместо того, чтобы составлять полный адресный план, вы можете взять открытый источник геоданных OpenStreetMap, проверить и дополнить его с нашей помощью.']
            },
            {
                upper: '',
                title: 'Три набора данных',
                text: [
                    'Предоставим готовые наборы данных на вашу территорию: какие объекты OSM подтверждаются по другим источникам, какие были пропущены (в основном это ИЖС, гаражи и сараи), какие могут оказаться лишними.',
                    'И обогатим OSM кодами ФИАС, кадастровыми номерами ЗУ и ОКС, более полными адресами и более точным вариантом координатного описания.'
                ]
            },
            {
                upper: '',
                title: 'Регулярные обновления',
                text: ['Мир и карты меняются ежедневно. Можно подписаться на регулярные обновления картосновы на особых условиях.']
            }
        ],
        footer: {
            text: ['На 70% больше строений,', '22% получат адрес, 57% связь с ЕГРН']
        },
        report: {
            button: "Отчет",
            header: "Отчет по территории",
            hint: "Оставьте свои контакты, мы свяжемся с вами",
            thanks: "Мы с вами свяжемся!",
            noRegionStub: "или обсудить любые другие вопросы",
            placeholder: "Почта или телефон",
            whereFromPlaceholder: "Откуда вы",
            request: "Запросить отчет"
        },
        drawing: {
            default: 'Проверить вашу территорию',
            start: 'Указать территорию',
            stop: 'Прекратить рисование'
        }
    },

    layers: [
        {
            id: "regions",
            label: "Регионы",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_163/{z}/{x}/{y}.pbf",
            maxZoom: 10,
            style: (p) => {
                return (p.properties_.level === 1) && (p.properties_.countVerified > 0) ? DefaultStyle : undefined;
            },
            turned: true
        },
        {
            id: "municipalitets",
            label: "Муниципалитеты",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_163/{z}/{x}/{y}.pbf",
            maxZoom: 10,
            style: (p) => {
                return (p.properties_.level === 2) && (p.properties_.countVerified > 0) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "settlements",
            label: "Поселения",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_163/{z}/{x}/{y}.pbf",
            maxZoom: 10,
            style: (p) => {
                return (p.properties_.level === 3) && (p.properties_.countVerified > 0) ? DefaultStyle : undefined;
            },
            turned: false
        },
        {
            id: "samples",
            label: "Образец настоящих данных",
            url: "https://rk.geosamara.ru/mvtserver/RN_1_164/{z}/{x}/{y}.pbf",
            maxZoom: 17,
            style: (p) => {
                if (p.properties_.origin === 'osm_houses_verified') {
                    let strokeColor = "#FF954F";

                    let extended = p.properties_.extended ? JSON.parse(p.properties_.extended) : null;
                    if (
                        ((!p.properties_.Street || (p.properties_.Street === '')) && (extended && extended.Street.length > 0)) ||
                        ((!p.properties_.HouseNumber || (p.properties_.HouseNumber === '')) && (extended && extended.HouseNumber.length > 0))
                    ) {
                        strokeColor = '#00A513';
                    }

                    return new Style({
                        stroke: new Stroke({
                            color: strokeColor,
                            width: 1
                        }),
                        fill: new Fill({
                            color: [255, 147, 79, 0.7]
                        }),
                    });
                }
                if (p.properties_.origin === 'osm_houses_unverified') {
                    return SamplesVerifiedStyle;
                }
                if (p.properties_.origin === 'osm_houses_missed') {
                    let fillOpacity = (p.properties_.BuildingType && p.properties_.BuildingType.length > 0) ? 0.7 : 0.1;

                    return new Style({
                        stroke: new Stroke({
                            color: "#00A513",
                            width: 1
                        }),
                        fill: new Fill({
                            color: [0, 165, 19, fillOpacity]
                        }),
                    });;
                }

                return undefined;
            },
            turned: false,
            afterTurned: (view) => {
                view.setCenter([5587958, 7016790]);
                view.setZoom(15);
            }
        }
    ],
    featureInfo: {
        properties: [
            { name: 'Подтвержденных объектов', field: "countVerified", unit: "шт", style: { color: '#E69138' } },
            { name: 'Дополнены адресом', field: "countExtendedAddress", unit: "шт", style: { fontSize: '30px' } },

            { name: 'Дополнительно нашлось еще', field: "countMissed", unit: "шт", style: { color: '#6AA84F' } },
            {
                name: 'В числе дополнительных',
                field: (p) => {
                    if (p.countMissed > 0) {
                        let text = '';
                        text += 'ИЖС - ' + (p.missedIZHS / p.countMissed * 100).toFixed(0) + '% (' + p.missedIZHS + ' шт)';
                        text += ', гаражи и сараи - ' + (p.missedGarages / p.countMissed * 100).toFixed(0) + '% (' + p.missedGarages + ' шт)';

                        return text;
                    }
                    return null;
                },
                longText: true,
                style: { fontSize: '24px' }
            },
            { name: 'Связаны с ГАР/ФИАС', field: "hasFIAS", unit: "шт", style: { fontSize: '30px' } },
            { name: 'С земельными участками', field: "hasLands", unit: "шт", style: { fontSize: '30px' } },
            { name: 'С ОКС', field: "hasOKS", unit: "шт", style: { fontSize: '30px' } },

            //{ name: 'Лишних объектов', field: "countUnverified", unit: "шт" },
            {
                name: 'Статус объекта',
                field: (p) => {
                    if (p.origin === 'osm_houses_verified') {
                        return 'Объект подтвержден';
                    }
                    if (p.origin === 'osm_houses_unverified') {
                        return 'Объект не подтвержден, возможно, что лишний';
                    }
                    return null;
                },
                longText: true,
                style: { color: '#E69138' }
            },
            {
                name: 'Статус объекта',
                field: (p) => {
                    if (p.origin === 'osm_houses_missed') {
                        return 'Кандидат на добавление в OSM';
                    }
                    return null;
                },
                longText: true,
                style: { color: '#6AA84F' }
            },
            {
                name: 'Уточнение адреса',
                field: (p) => {
                    if (p.origin === 'osm_houses_verified') {
                        let extended = p.extended ? JSON.parse(p.extended) : null;
                        if (
                            ((!p.Street || (p.Street === '')) && (extended && extended.Street.length > 0)) ||
                            ((!p.HouseNumber || (p.HouseNumber === '')) && (extended && extended.HouseNumber.length > 0))
                        ) {
                            return (extended.Street ? extended.Street + ', ' : '') + (extended.HouseNumber ? extended.HouseNumber : 'адрес не полный');
                        }
                    }
                },
                longText: true
            },
            {
                name: 'Назначение',
                field: (p) => {
                    let extended = p.extended ? JSON.parse(p.extended) : null;

                    return extended ? extended.BuildingType : p.BuildingType;

                }, longText: true, style: { fontSize: '30px' }
            },
            {
                name: 'Код ГАР/ФИАС',
                field: (p) => {
                    if (p.origin) {
                        let extended = p.extended ? JSON.parse(p.extended) : null;
                        let sources = p.sources ? JSON.parse(p.sources) : (extended ? extended.sources : null);
                        if (sources && sources.fias) {
                            let ids = sources.fias.join(', ');
                            if (ids.length > 100) { ids = ids.substring(0, 100) + '...' }
                            return ids;
                        }
                    }
                },
                longText: true,
                style: { fontSize: '20px' }
            },

            {
                name: 'Земельный участок',
                field: (p) => {
                    if (p.origin) {
                        let extended = p.extended ? JSON.parse(p.extended) : null;
                        let sources = p.sources ? JSON.parse(p.sources) : (extended ? extended.sources : null);
                        if (sources && sources.lands) {
                            let ids = sources.lands.join(', ');
                            if (ids.length > 100) { ids = ids.substring(0, 100) + '...' }
                            return ids;
                        }
                    }
                },
                longText: true,
                style: { fontSize: '20px' }
            },

            {
                name: 'ОКС',
                field: (p) => {
                    if (p.origin) {
                        let extended = p.extended ? JSON.parse(p.extended) : null;
                        let sources = p.sources ? JSON.parse(p.sources) : (extended ? extended.sources : null);
                        if (sources && sources.oks) {
                            let ids = sources.oks.join(', ');
                            if (ids.length > 100) { ids = ids.substring(0, 100) + '...' }
                            return ids;
                        }
                    }
                },
                longText: true,
                style: { fontSize: '20px' }
            },


        ],
        territoryNameFunc: (properties) => {
            return (properties.Street && properties.HouseNumber) ? properties.Street + ' ' + properties.HouseNumber :
                (properties.level === 2) ? (properties.region + ', ' || '') + (properties.municipalitet || '') :
                    (properties.level === 3) ? (properties.region + ', ' || '') + (properties.municipalitet + ', ' || '') + (properties.settlement || '') :
                        (properties.region || '');
        },
        headerFunc: (properties) => {
            return properties.origin ?
                (properties.Street && properties.HouseNumber) ? properties.Street + ' ' + properties.HouseNumber : 'без адреса'
                :
                (properties.level === 2) ? properties.municipalitet :
                    (properties.level === 3) ? properties.settlement : properties.region;
        },
        subHeaderFunc: (properties) => {
            return properties.origin ?
                [properties.Region, properties.Municipalitet].filter(s => s).join(', ')
                :
                (properties.level === 2) ? properties.region :
                    (properties.level === 3) ? properties.municipalitet + ', ' + properties.region : '';;
        }
    },
    featureId: (feature) => {
        return Hash.SHA1((feature.properties_.ID || '') + (feature.properties_.oapID || '') + (feature.properties_.region || '') + (feature.properties_.level || '') + (feature.properties_.municipalitet || '') + (feature.properties_.settlement || ''));
    }
}


